
import {
  Typography,
  Divider,
  Card,
  CardHeader,
  CardContent,
  Tooltip,
  styled
} from "@mui/material";
import { tooltipClasses } from "@mui/material/Tooltip";

const MetadataTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#EAFFD8",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    background: "#EAFFD8",
    color: "#2B2B2B",
    maxWidth: "400px",
    boxShadow: "4px 20px 36px 8px #1D1D1B14",
    border: "1px solid #164A1A",
    padding: 0,
  },
}));

const AssetMetadata = ({
  title,
  metadata,
  disableTooltip=false,
  children
}) => {

  const formatMetadata = (fileMetadata) => {
    let _metadata = Object.entries(fileMetadata);

    return _metadata.map(([key,value]) => {
      return {
        "name": key.replaceAll("_"," ").replace("species taxa ",""),
        "value": value
      }
    })

  };

  return (
    <MetadataTooltip
      arrow
      sx={{
        zIndex: 99999999,
      }}
      placement="top"
      disableFocusListener
      disableTouchListener
      disableHoverListener={disableTooltip}
      title={
      <Card
        sx={{
          height: "100%",
          background: "#EAFFD8",
          padding: 0,
          margin: 0,
        }}
      >
        <CardHeader
          sx={{ padding: "1rem", pb: "0.5rem" }}
          title={
            <Typography
              variant="h4"
              sx={{
                fontFamily: "MADE TOMMY",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "17px",
                letterSpacing: "0px",
                textAlign: "left",
                color: "#2B2B2B",
                paddingBottom: "0.5rem",
                textTransform: "capitalize",
              }}
            >
              {title}
            </Typography>}
          subheader={
            <Typography
              variant="span"
              sx={{
                fontFamily: "MADE TOMMY",
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "17px",
                letterSpacing: "0px",
                textAlign: "left",
                color: "#2B2B2B",
                paddingBottom: "0rem",
                textTransform: "capitalize",
              }}
            >
              File metadata
            </Typography>
          }
        ></CardHeader>
        <Divider sx={{ border: "1px solid #164A1A" }} />
        <CardContent sx={{ padding: "1rem", maxHeight: "250px", overflow: "auto"}}>
          {(metadata === undefined || metadata === null) && "There is no metadata for this file"}
          {(metadata !== undefined && metadata !== null) &&
          <>
                {
                  formatMetadata(metadata).map((field,idx) => (
                    <div key={idx} style={{
                      borderBottom: "1px solid #b9b9b9",
                      paddingBottom: "5px",
                      marginBottom: "5px"
                    }}>
                      <Typography variant="span" sx={{ fontWeight: 700, fontSize: "12px", textTransform: "capitalize"}}>{field.name}:</Typography>
                      <Typography variant="span" sx={{ fontWeight: 400, fontSize: "12px", pl: 1 }}>{field.value}</Typography>
                    </div>
                  ))
                }
          </>
          }
        </CardContent>
      </Card>}
    >
      {children}
    </MetadataTooltip>
  );
};

export default AssetMetadata;
